<template>
  <q-item :to="menuLink.to" :href="menuLink.href" clickable>
    <q-item-section side>
      <q-icon :name="menuLink.icon" size="xs" />
    </q-item-section>
    <q-item-section>
      {{ menuLink.label() }}
    </q-item-section>

    <q-item-section side>
      <q-icon name="fa-solid fa-angle-right" size="12px" />
    </q-item-section>
  </q-item>
</template>

<script setup lang="ts">
import type { MergedLinks } from 'types/common/layout/layout'

defineProps<{
  menuLink: MergedLinks
}>()
</script>
